<template>
  <div>
    <h2>Выгрузка актов за период</h2>
    <div class="statistics-actions">
      <button
          class="btn statistics-excel-btn"
          type="button"
          :disabled="isExporting"
          @click="openExportModal"
      >
        {{ isExporting ? 'Формирование...' : 'Скачать отчет Excel' }}
      </button>
      <button
          v-if="isAdminOrRootAdmin"
          class="btn statistics-pdf-btn"
          type="button"
          :disabled="isExporting"
          @click="openPdfExportModal"
      >
        {{ isExporting ? 'Формирование...' : 'Скачать отчеты PDF' }}
      </button>
    </div>
  </div>
</template>

<script>
import { fileDownload } from "@/utils/fileDownload";
import DateRangeModal from "@/components/profilePage/DateRangeModal";
import { DateRangeModalProperties } from "@/utils/modalsProperties";
import {
  MAX_PDF_REPORT_PERIOD_MONTHS,
  MAX_PDF_REPORT_PERIOD_ERROR,
} from "@/utils/datetime";
import { mapGetters } from "vuex";

export default {
  name: "Statistics",
  data() {
    return {
      isExporting: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["authorities"]),
    isAdminOrRootAdmin() {
      return (
        this.authorities.includes("ROLE_ADMIN") ||
        this.authorities.includes("ROLE_ROOT_ADMIN")
      );
    },
  },
  methods: {
    openExportModal() {
      this.$modal.show(
          DateRangeModal,
          {
            onSubmit: this.handleExport,
          },
          DateRangeModalProperties,
      );
    },
    openPdfExportModal() {
      this.$modal.show(
          DateRangeModal,
          {
            onSubmit: this.handlePdfExport,
            // для pdf-отчётов период выгрузки ограничен 6 месяцами
            maxPeriodMonths: MAX_PDF_REPORT_PERIOD_MONTHS,
            periodErrorMessage: MAX_PDF_REPORT_PERIOD_ERROR,
          },
          DateRangeModalProperties,
      );
    },
    async handleExport({ start, end }) {
      // закрываем окно с периодом выборки сразу после нажатия "Скачать отчет"
      this.$modal.close();
      this.isExporting = true;
      try {
        const response = await this.$store.dispatch("subscriptions/exportSubscriptionsToExcel", {
          start,
          end,
        });
        fileDownload({
          headers: response.headers,
          data: response.data,
        });
      } catch (e) {
        this.$toast.error(e.message || "Ошибка при формировании отчёта");
      } finally {
        this.isExporting = false;
      }
    },
    async handlePdfExport({ start, end }) {
      this.$modal.close();
      this.isExporting = true;
      try {
        const response = await this.$store.dispatch("subscriptions/exportSubscriptionsToPdf", {
          start,
          end,
        });
        fileDownload({
          headers: response.headers,
          data: response.data,
        });
      } catch (e) {
        this.$toast.error(e.message || "Ошибка при формировании отчёта");
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.statistics-actions {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}

.statistics-excel-btn {
  background-color: #4caf50;
  color: #fff;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: #388e3c;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.statistics-pdf-btn {
  background-color: #f44336;
  color: #fff;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: #d32f2f;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>

